import './style.css';
import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, normalizeClass, unref, toDisplayString, renderSlot, pushScopeId, popScopeId, createTextVNode } from 'vue';

var error_vue_vue_type_style_index_0_scoped_true_lang = '';

var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};

const _withScopeId = (n) => (pushScopeId("data-v-bf14f60e"), n = n(), popScopeId(), n);
const _hoisted_1 = { class: "error-page" };
const _hoisted_2 = { class: "bullshit" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "bullshit-headline" }, "\u62B1\u6B49\uFF0C\u60A8\u8BBF\u95EE\u7684\u9875\u9762\u4E0D\u5B58\u5728", -1));
const _hoisted_5 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "bullshit-info" }, [
  /* @__PURE__ */ createTextVNode(" \u8BF7\u5C1D\u8BD5\u4EE5\u4E0B\u529E\u6CD5\uFF1A"),
  /* @__PURE__ */ createElementVNode("br"),
  /* @__PURE__ */ createTextVNode(" \xB7 \u68C0\u67E5\u60A8\u8F93\u5165\u7684\u7F51\u5740\u662F\u5426\u6B63\u786E"),
  /* @__PURE__ */ createElementVNode("br"),
  /* @__PURE__ */ createTextVNode(" \xB7 \u68C0\u67E5\u4EE3\u7406\u670D\u52A1\u5668\u548C\u9632\u706B\u5899"),
  /* @__PURE__ */ createElementVNode("br"),
  /* @__PURE__ */ createTextVNode(" \xB7 \u8FDB\u884C\u7F51\u7EDC\u8BCA\u65AD ")
], -1));
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
];
const _hoisted_7 = { key: 1 };
const _hoisted_8 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "bullshit-headline" }, "\u62B1\u6B49\uFF0C\u60A8\u65E0\u6743\u8BBF\u95EE\u8BE5\u9875\u9762", -1));
const _hoisted_9 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "bullshit-info" }, "\u5982\u6709\u9700\u8981\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u5F00\u901A\u6743\u9650", -1));
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
];
const _hoisted_11 = { key: 2 };
const _hoisted_12 = { class: "bullshit-headline" };
const _hoisted_13 = { class: "bullshit-info" };
const _hoisted_14 = { class: "action-box" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "error",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    defaultTarget: {
      type: String,
      default: "/idx/home"
    }
  },
  emits: ["btn-click", "logout"],
  setup(__props, { emit }) {
    const props = __props;
    const DEFAULT_DATA = {
      code: 404,
      title: "",
      message: "\u9875\u9762\u51FA\u9519\u4E86~",
      buttonLabel: "\u8FD4\u56DE\u9996\u9875"
    };
    const LOGOUT_CODES = [
      401,
      20100001,
      30550012,
      1e5
    ];
    const error = computed(() => {
      return props.data || DEFAULT_DATA;
    });
    const errorType = computed(() => {
      if (error.value && error.value.code === 404) {
        return "1";
      } else if (error.value && error.value.code === 403) {
        return "2";
      } else {
        return "3";
      }
    });
    const btnLabel = computed(() => {
      if (LOGOUT_CODES.includes(error.value.code)) {
        return "\u9000\u51FA";
      }
      return error.value && error.value.buttonLabel || "\u8FD4\u56DE\u9996\u9875 >";
    });
    function logout() {
      emit("logout");
    }
    function btnClick() {
      const { code, target } = error.value;
      if (LOGOUT_CODES.includes(code)) {
        logout();
        return;
      }
      if (target) {
        emit("btn-click", target);
      } else {
        emit("btn-click", props.defaultTarget);
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", {
          class: normalizeClass(["pic-404", `img-${unref(errorType)}`])
        }, null, 2),
        createElementVNode("div", _hoisted_2, [
          unref(errorType) === "1" ? (openBlock(), createElementBlock("div", _hoisted_3, _hoisted_6)) : unref(errorType) === "2" ? (openBlock(), createElementBlock("div", _hoisted_7, _hoisted_10)) : (openBlock(), createElementBlock("div", _hoisted_11, [
            createElementVNode("div", _hoisted_12, toDisplayString(unref(error).title || "\u8BBF\u95EE\u51FA\u9519\uFF01"), 1),
            createElementVNode("div", _hoisted_13, toDisplayString(unref(error).message || ""), 1),
            renderSlot(_ctx.$slots, "message", {}, void 0, true)
          ])),
          createElementVNode("div", _hoisted_14, [
            createElementVNode("button", {
              class: "login-btn",
              onClick: btnClick
            }, toDisplayString(unref(btnLabel)), 1)
          ]),
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ])
      ]);
    };
  }
});
var error = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-bf14f60e"]]);

export { error as CommonError };
